import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Cidade } from '../interfaces/cidade';
import { catchError, tap, filter } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class CidadeService {

  readonly path = '/cidade';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) {}

  getCidade(code: number ): Observable<Cidade> {
    return this.http.get<Cidade>(`${this.jwtAuthService.apiUrl + this.path}/${code}`);
  }

  getCidadePage(page?: number, size?: number): Observable<PageResult<Cidade>> {
    const params = new HttpParams()
      .set('page', String(page ?? 1))
      .set('size', String(size ?? 20));
    return this.http.get<PageResult<Cidade>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/`, { params });
  }

  getCidadeIbge(code: string ): Observable<Cidade> {
    return this.http.get<Cidade>(`${this.jwtAuthService.apiUrl + this.path}/ibge/${code}`);
  }

  getCidadePageSearch(page?: number, size?: number, search?: string): Observable<PageResult<Cidade>> {
    let params = new HttpParams()
      .set('page', String(page ?? 1))
      .set('size', String(size ?? 20));
    if (search != null && String(search).trim() !== '') {
      params = params.set('search', String(search).trim());
    }
    return this.http.get<PageResult<Cidade>>(`${this.jwtAuthService.apiUrl + this.path}/page/get`, { params });
  }

  consultarConvenioNfseNacionalPorIbge(codigoIbge: number | string): Observable<any> {
    return this.http.get<any>(`${this.jwtAuthService.apiUrl + this.path}/nfse/convenio/${codigoIbge}`);
  }

  getItemCidadePageSearch(page?: number, size?: number,  search?: string,
    order?: string, direction?: string): Observable<PageResult<Cidade>> {
    let params = new HttpParams()
      .set('page', String(page ?? 1))
      .set('size', String(size ?? 20))
      .set('order', order ?? 'NENHUM')
      .set('direction', direction ?? 'ASC');
    if (search != null && String(search).trim() !== '') {
      params = params.set('search', String(search).trim());
    }
    return this.http.get<PageResult<Cidade>>(`${this.jwtAuthService.apiUrl + this.path}/page/get`, { params });
  }

  saveOrUpdate(cadastro: Cidade): Observable<Cidade> {
    return this.http.put<Cidade>(`${this.jwtAuthService.apiUrl + this.path}`, cadastro);
  }
}

